function a(e, n) {
  const t = `${e.name.replace(/\.[^.]+$/, "")}.png`;
  return new File([n], t, {
    type: "image/png",
    lastModified: e.lastModified
  });
}
export {
  a as replaceImageFileBlob
};
